import styled from 'styled-components';
import { Box } from '@mui/material';

export const CustomerValidationWrapper = styled(Box)`
display: flex;
width: 100%;
    justify-content: space-between;
.d-flex{
    border: 1px solid #1B4A83;
        padding: 20px 36px;
            justify-content: space-between;
    flex-wrap: wrap;
    width:90%;
border-radius: 5px;
  img{
      display: flex;
  }
    .customerDetails{
        width: 30%;
            text-align: start;
    display: flex;
      .imgIcon{
          
    margin: 27px 0 -35px 34px;
     
    }
    .contentUser{
        padding: 0 10px;
            margin: 17px 0;
            h4{
                color: #1B4A83;
                font-size: 18px;
                margin: 0;
                font-weight: 500;

            }
            p{
                color: #2A2725;
                font-weight: 600;
                margin: 0;
                font-size: 18px;
            }
             .para1 {
                color: rgb(35, 145, 85) ;
                font-weight: 600;
                margin: 0;
                font-size: 18px;
            }
    }
}


`;

          